import Swal from 'sweetalert2';

export const SuccessMessage = title => {
    Swal.mixin({
        toast: true,
        position: 'top-start',
        showConfirmButton: false,
        timer: 5000,
        background: '#d4edda'
    }).fire({
        icon: 'success',
        title
    })
}

export const WaitingMessage = title => {
    Swal.fire({
        title,
        text: 'Por favor aguarde.',
        onBeforeOpen: () => {
            Swal.showLoading()
        },
        allowOutsideClick: false
    });
}

export const ErrorMessage = title => {
    Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 5000,
        background: '#f8d7da'
    }).fire({
        icon: 'error',
        title
    })
}

export const ErrorMessageWithAction = (data, handle) => {
    Swal.fire({
        title: 'Error',
        text: data.text,
        icon: 'error',
        showCancelButton: false,
        confirmButtonColor: '#e74a3b',
        confirmButtonText: 'Aceptar'
    }).then((result) => {
        if(result.value){
            handle();
        }
    })
}

export const ConfirmDeleteMessage = (title, text, handle) => {
    Swal.fire({
        title,
        text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#e74a3b',
        confirmButtonText: 'Si, Eliminar'
    }).then((result) => {
        if(result.value){
            handle();
        }
    })
}

export const ConfirmMessage = (data, handle) => {
    Swal.fire({
        title: data.title,
        text: data.text,
        icon: data.icon,
        showCancelButton: data.showCancelButton,
        confirmButtonColor: data.confirmButtonColor,
        confirmButtonText: data.confirmButtonText
    }).then((result) => {
        if(result.value){
            handle();
        }
    })
}